import React from 'react';
import { YStack } from '@tamagui/stacks';
import { Text } from '@tamagui/core';

type SectionHeaderProps = {
  title: string;
  textColor: string;
};

const SectionHeader = React.memo<SectionHeaderProps>(({ title, textColor }) => {
  return (
    <YStack paddingHorizontal="$4" paddingBottom="$3">
      <Text fontSize={18} fontWeight="700" color={textColor}>
        {title}
      </Text>
    </YStack>
  );
});

SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;

